import { storyblokEditable } from '@storyblok/react/rsc'
import { type FC } from 'react'

import { type StoryblokComponentProps } from '../../model'
import { type StoryblokCardCarouselType } from '../../model/storyblokTypes.generated'
import { StoryblokComponentsRenderer } from '../StoryblokComponentsRenderer'

export const StoryblokCardCarousel: FC<
  StoryblokComponentProps<StoryblokCardCarouselType>
> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)} className="w-full" data-carousel="slide">
      <div className="flex snap-x gap-4 overflow-x-auto scroll-smooth scrollbar-hide tablet:justify-between">
        <StoryblokComponentsRenderer bloks={blok.cards} />
      </div>
    </div>
  )
}
